import { useEffect } from 'react';
import { projectRepository } from '@/storage/repositories/IndexedDbProjectRepository';
import { useProjectLibrary } from '@/features/project-library/projectLibraryStore';
import { initializeLibrary } from './initializeLibrary';
const SAVE_DEBOUNCE_MS = 400;
/**
 * Ponte entre o store Zustand e o ProjectRepository (IndexedDB).
 *
 * - Hidratação é delegada para `initializeLibrary()` (singleton de módulo),
 *   imune ao double-mount do Strict Mode.
 * - Esta bridge só gerencia a subscrição de auto-save com debounce por projeto.
 */
export function PersistenceBridge() {
    useEffect(() => {
        initializeLibrary();
    }, []);
    useEffect(() => {
        const saveTimers = new Map();
        function scheduleSave(id, project) {
            const existing = saveTimers.get(id);
            if (existing)
                clearTimeout(existing);
            const t = setTimeout(() => {
                saveTimers.delete(id);
                projectRepository.save(project).catch((err) => {
                    console.error('[persistence] save failed', id, err);
                });
            }, SAVE_DEBOUNCE_MS);
            saveTimers.set(id, t);
        }
        const unsubscribe = useProjectLibrary.subscribe((state, prev) => {
            if (state.hydrationStatus !== 'ready')
                return;
            if (state.projects === prev.projects)
                return;
            for (const id in state.projects) {
                if (state.projects[id] !== prev.projects[id]) {
                    scheduleSave(id, state.projects[id]);
                }
            }
            for (const id in prev.projects) {
                if (!(id in state.projects)) {
                    const t = saveTimers.get(id);
                    if (t) {
                        clearTimeout(t);
                        saveTimers.delete(id);
                    }
                    projectRepository.delete(id).catch((err) => {
                        console.error('[persistence] delete failed', id, err);
                    });
                }
            }
        });
        return () => {
            unsubscribe();
            saveTimers.forEach((t) => clearTimeout(t));
            saveTimers.clear();
        };
    }, []);
    return null;
}
